module.exports = __webpack_public_path__ + "media/images/countryrect/il-f5287e52d1adcfe7cd647ccfa1bf15c9.svg";